import React, { useState, useEffect } from 'react';
import heroImg from "./img/matthew-lejune-IpvDhQjrewM-unsplash.jpg";
import logo from "./img/logo.png";
import riverWalk from "./img/anna-breaux-nYnN2A9hfQk-unsplash.jpg";
import books from "./img/inaki-del-olmo-NIJuEQw0RKg-unsplash.jpg";
import { 
  Building,
  Lightbulb,
  DollarSignIcon,
  Scroll,
  Leaf,
  Scale
} from 'lucide-react';
import ourOffice from "./img/river-walk.jpg"
import './index.css';
import Attorneys from './Attorneys';

const App = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [activeSection, setActiveSection] = useState('home');
  const [menuOpen, setMenuOpen] = useState(false);

  const practiceAreas = [
    { 
      title: 'Land Use and Entitlements', 
      icon: Building, 
      desc: '' 
    },
    { 
      title: 'Economic Incentives', 
      icon: DollarSignIcon, 
      desc: '' 
    },
    { 
      title: 'Government Relations', 
      icon: Scale, 
      desc: '' 
    },
    { 
      title: 'Historic Compliance', 
      icon: Scroll, 
      desc: '' 
    },
    { 
      title: 'Environmental Compliance', 
      icon: Leaf, 
      desc: '' 
    },
    { 
      title: 'Public Utility Law', 
      icon: Lightbulb, 
      desc: '' 
    }
  ];

  useEffect(() => {
    setIsLoaded(true);
  }, []);

  const scrollToSection = (sectionId) => {
    setActiveSection(sectionId);
    setMenuOpen(false);
    document.getElementById(sectionId).scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className={`min-h-screen font-serif bg-gray-50 text-gray-800 ${isLoaded ? 'opacity-100' : 'opacity-0'} transition-opacity duration-1000`}>
      {/* Header */}
      <header className="fixed w-full bg-white shadow-md z-50 transition-all duration-500">
        <div className="container mx-auto px-6 py-4 flex justify-between items-center">
          <div className="flex items-center space-x-2">
            <img className="text-3xl font-bold text-gray-800" src={logo} style={{maxWidth: "300px"}}></img>
            {/* <div className="text-3xl font-bold text-gray-800">ANDERSON<span className="text-blue-800">&</span>PARTNERS</div> */}
          </div>
          
          {/* Desktop Navigation */}
          <nav className="hidden md:flex">
            <ul className="flex space-x-8">
              {['home', 'about', 'practice', 'attorneys', 'contact'].map((item) => (
                <li key={item}>
                  <button 
                    onClick={() => scrollToSection(item)}
                    className={`uppercase text-sm tracking-wide transition-colors duration-300 ${activeSection === item ? 'text-blue-800 font-bold' : 'text-gray-600 hover:text-blue-800'}`}
                  >
                    {item === 'home' ? 'Home' : 
                     item === 'about' ? 'About Us' : 
                     item === 'practice' ? 'Practice Areas' : 
                     item === 'attorneys' ? 'Our Team' : 'Contact'}
                  </button>
                </li>
              ))}
            </ul>
          </nav>
          
          {/* Mobile Menu Button */}
          <button 
            className="md:hidden text-gray-600 focus:outline-none"
            onClick={() => setMenuOpen(!menuOpen)}
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              {menuOpen ? (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>
        
        {/* Mobile Navigation */}
        <div className={`md:hidden bg-white shadow-inner transition-all duration-500 ${menuOpen ? 'max-h-64' : 'max-h-0'} overflow-hidden`}>
          <ul className="px-6 py-4 space-y-4">
            {['home', 'about', 'practice', 'attorneys', 'contact'].map((item) => (
              <li key={item}>
                <button 
                  onClick={() => scrollToSection(item)}
                  className={`block w-full text-left uppercase text-sm tracking-wide transition-colors duration-300 ${activeSection === item ? 'text-blue-800 font-bold' : 'text-gray-600'}`}
                >
                  {item === 'home' ? 'Home' : 
                   item === 'about' ? 'About Us' : 
                   item === 'practice' ? 'Practice Areas' : 
                   item === 'attorneys' ? 'Our Team' : 'Contact'}
                </button>
              </li>
            ))}
          </ul>
        </div>
      </header>

      {/* Hero Section */}
      <section id="home" className="pt-24 min-h-screen flex items-center bg-gradient-to-r from-blue-900 to-gray-900 relative overflow-hidden">
        <div className="absolute inset-0 bg-black opacity-50 z-10"></div>
        <div className="absolute inset-0 z-0">
          <img src={heroImg} alt="Law Firm Office" className="w-full h-full object-cover" />
        </div>
          {/* Dark Overlay */}
        <div className="absolute inset-0 bg-black opacity-50"></div>
        <div className="container mx-auto px-6 py-32 relative z-20">
          <div className="max-w-3xl mx-auto text-center">
            <h1 className={`text-5xl md:text-6xl font-playfair text-white mb-8 ${isLoaded ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'} transition-all duration-1000 delay-300`}>
              Experience you can trust. Results you can rely on.
            </h1>
            <div className="mt-1">.</div>
            <p className={`text-xl md:text-2xl font-abel italic text-gray-200 mb-12 ${isLoaded ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'} transition-all duration-1000 delay-500`}>
            40+ Years of Experience Serving your Land Use Planning and Development Needs
            </p>
            <div className={`flex flex-col md:flex-row justify-center space-y-4 md:space-y-0 md:space-x-6 ${isLoaded ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'} transition-all duration-1000 delay-700`}>
              <button onClick={() => scrollToSection('contact')} className="px-8 py-3 bg-blue-800 text-white uppercase tracking-wider font-medium hover:bg-blue-700 transition-colors duration-300">
                Contact Us
              </button>
              <button onClick={() => scrollToSection('practice')} className="px-8 py-3 bg-transparent border-2 border-white text-white uppercase tracking-wider font-medium hover:bg-white hover:text-blue-900 transition-colors duration-300">
                Our Practice Areas
              </button>
            </div>
          </div>
        </div>
      </section>

       {/* About Section - Horizontal Layout */}
    <section id="about" className="py-24 bg-white">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-3xl md:text-6xl font-playfair text-green-700 mb-16 text-center">About Our Firm</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
            <div className="order-2 md:order-1">
              <div className="space-y-6">
                <p className="text-xl font-abel text-green-700 text-justify">
                  At Brown & McDonald PLLC, we are dedicated to providing comprehensive land use services to our clients. With decades of experience in the industry, primarily in the San Antonio and the greater Bexar County area, our team of experts has developed a deep understanding of the complex issues involved in land use planning, zoning, and development and we are committed to finding innovative solutions to meet the unique needs of our clients. Our experience and longevity have helped build the trust and credibility necessary for success in this practice area and we are proud to say that our longstanding relationships with public officials, governmental staff, and industry partners are one of our greatest assets for our clients.
                </p>
                <p className="text-xl font-abel text-green-700 text-justify">
                We understand that every project is unique and attention to detail is required for a successful project. That's why we take pride in our collaborative approach with our clients while developing tailored strategies that meet their needs and, oftentimes, exceed their expectations. Whether it's navigating zoning and permitting regulations, securing economic incentives, or just general advocacy for our clients, we bring a wealth of knowledge and expertise to every project and every issue. Our commitment to excellence extends beyond just getting the job done. We prioritize transparency, communication, and collaboration throughout the entire process, ensuring that our clients are informed and engaged every step of the way. With a track record of successful projects and satisfied clients, we are proud to be a trusted partner for all of our clients' land use needs, zoning, and developmental needs.
                </p>
                <div className="pt-8">
                  <button className="px-6 py-3 bg-blue-800 text-white uppercase tracking-wider text-sm font-medium hover:bg-blue-700 transition-colors duration-300"
                    onClick={() => scrollToSection('attorneys')}
                  >
                    Meet Our Team
                  </button>
                </div>
              </div>
            </div>
            <div className="order-1 md:order-2 relative">
              <div className="aspect-w-16 aspect-h-9 rounded-lg overflow-hidden shadow-xl">
                <img 
                  src={ourOffice} 
                  alt="Law Firm Office" 
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-black opacity-10"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

      {/* Practice Areas */}
      <section id="practice" className="py-24 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url(${books})`,
          backgroundColor: 'rgba(0,0,0,0.7)', // Optional: add a dark overlay
          backgroundBlendMode: 'multiply' // Helps darken the image
        }}
      >
        <div className="container mx-auto px-6">
          <h2 className="text-3xl md:text-6xl font-playfair text-white mb-16 text-center">Our Practice Areas</h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {practiceAreas.map((area, index) => (
              <div 
                key={index} 
                className="bg-white p-8 rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300 text-center"
              >
                <div className="flex justify-center mb-4">
                  <area.icon 
                    className="w-12 h-12 text-blue-800" 
                    strokeWidth={1.5} 
                  />
                </div>
                <h3 className="text-xl font-abel font-bold mb-4 text-gray-800">{area.title}</h3>
                <p className="text-gray-700">{area.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Attorneys */}
      <Attorneys />

      {/* Contact */}
      <section id="contact" className="py-24 bg-blue-700">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl md:text-6xl font-playfair text-green-700 mb-16 text-center">Contact Us</h2>
            <div className="grid md:grid-cols-2 gap-12">
              <div className="space-y-8">
                <div>
                  <h3 className="text-xl mb-4 text-gray-800">OUR OFFICE</h3>
                  <p className="text-gray-700">One International Center, 100 NE Loop 410, 	Suite 1385,<br></br> San Antonio, Texas 78216</p>
                </div>
                <div>
                  <h3 className="text-xl mb-4 text-gray-800">CONTACT INFORMATION</h3>
                  <p className="text-gray-700">Phone: (210)-429-7931<br />Email: info@brownmcdonaldlaw.com</p>
                </div>
                <div>
                  <h3 className="text-xl mb-4 text-gray-800">BUSINESS HOURS</h3>
                  <p className="text-gray-700">Monday - Friday: 9:00 AM - 6:00 PM<br />Weekends: By Appointment</p>
                </div>
              </div>
              <div className="aspect-w-16 aspect-h-9 rounded-lg overflow-hidden shadow-xl">
                <img 
                  src={riverWalk} 
                  alt="river-walk" 
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="container mx-auto px-6">
          <div className="grid md:grid-cols-4 gap-12">
            <div>
              <h4 className="text-xl mb-6">BROWN & MCDONALD</h4>
              <p className="text-gray-400">40+ Years of Experience Serving your Land Use Planning and Development Needs</p>
            </div>
            <div>
              <h4 className="text-xl mb-6">QUICK LINKS</h4>
              <ul className="space-y-3">
                {['home', 'about', 'practice', 'attorneys', 'contact'].map((item) => (
                  <li key={item}>
                    <button 
                      onClick={() => scrollToSection(item)}
                      className="text-gray-400 hover:text-white transition-colors duration-300"
                    >
                      {item === 'home' ? 'Home' : 
                       item === 'about' ? 'About Us' : 
                       item === 'practice' ? 'Practice Areas' : 
                       item === 'attorneys' ? 'Our Team' : 'Contact'}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h4 className="text-xl mb-6">PRACTICE AREAS</h4>
              <ul className="space-y-3">
                {['Land Use and Entitlements', 'Economic Incentives', 'Government Relations', 'Historic Compliance', 'Environmental Compliance', 'Public Utility Law'].map((item) => (
                  <li key={item}>
                    <button 
                      onClick={() => scrollToSection('practice')}
                      className="text-gray-400 hover:text-white transition-colors duration-300"
                    >
                      {item}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h4 className="text-xl mb-6">CONTACT</h4>
              <ul className="space-y-3 text-gray-400">
                <li>One International Center</li>
                <li>100 NE Loop 410</li>
                <li>Suite 1385</li>
                <li>San Antonio, Texas 78216</li>
                <li>(210)-429-7931</li>
                <li>info@brownmcdonaldlaw.com</li>
              </ul>
            </div>
          </div>
          <div className="border-t border-gray-800 mt-12 pt-8 text-center text-gray-500">
            <p>&copy; {new Date().getFullYear()} Brown & McDonald, Attorneys at Law. All rights reserved. 2025</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default App;